import React from "react";
import { useData } from "@/context/DataContext";
import LearningHubConcept2 from "./LearningHubConcept2";
import LearningHubLegacy from "./LearningHubLegacy";

/** Learning Hub route entry — reads the `learning_hub_revamped` global
 * setting (Control Panel → Feature flags) and renders the Concept-2
 * revamped mockup or the pre-mockup legacy page. Falls back to the
 * classic legacy experience when the setting hasn't loaded yet so
 * first paint isn't held up by the settings fetch. */
const LearningHubSwitch = () => {
    const { settings } = useData() || {};
    const revamped = settings?.learning_hub_revamped === true;
    return revamped ? <LearningHubConcept2 /> : <LearningHubLegacy />;
};

export default LearningHubSwitch;
